"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPrinterFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M19 9.007h1a2 2 0 012 2v6c0 1.333-.667 2-2 2h-1v1c0 1.333-.667 2-2 2H7c-1.333 0-2-.666-2-2v-1H4c-1.333 0-2-.667-2-2v-6a2 2 0 012-2h1v-4c0-1.654 1.218-3 2.714-3h6.282c.367-.027.686.026.956.161.27.135.62.415 1.048.84l2.125 2c.41.393.66.726.745 1 .087.274.13.608.13 1.003v1.996zm-12 11h10v-3H7v3zm0-15v4h10V6.693l-2.828-2.686H7.714c-.387 0-.714.458-.714 1zm12 8a1 1 0 100-2 1 1 0 000 2z' }))); };
exports.default = SvgPrinterFilled;
//# sourceMappingURL=PrinterFilled.js.map